<template>
  <div class="main-container mb-6 h-full">
    <div>
      <div class="mx-auto max-w-3xl w-full mb-6">
        <div class="text-2xl leading-loose mt-1">
          <h3>{{ $t("message.publishDocuments.title") }}</h3>
        </div>
      </div>
    </div>
    <div class="mx-auto">
      <div class="container bg-white max-w-3xl w-full p-0">
        <template v-if="loading">
          <vue-element-loading
            :active="loading"
            spinner="spinner"
            color="#4F41A3"
            style="height: 400px; margin: 0 400px; background-color: #00000000"
          />
        </template>
        <template v-else>
          <ConfigMassivePublish
            v-if="activeComponent === 'parameters'"
            @next-step="setNextStep"
            @goto-next-step="goTo(nextStep)"
            @cancel-process="cancelProcess"
          />

          <OnlyPublish
            v-if="
              activeComponent === 'onlyPublish' ||
              activeComponent === 'only_publish'
            "
            @go-back="activeComponent = 'parameters'"
            @toggle-modal="publishModalActive = true"
            @cancel-process="cancelProcess"
            :processData="processData"
            :splitTag="splitTag"
          />
          <OnlySign
            v-if="activeComponent === 'sign_and_publish'"
            @go-back="activeComponent = 'parameters'"
            @toggle-modal="publishModalActive = true"
            @cancel-process="cancelProcess"
            @sign-and-publish="
              (processTag) => {
                openModalPublish(processTag);
              }
            "
            @error-on-preview="
              (errorCode) => {
                activeErrorOnPreview(errorCode);
              }
            "
            :processData="processData"
          />
          <SplitAndCrop
            v-if="
              activeComponent === 'split_and_crop' ||
              activeComponent === 'split_crop_and_sign'
            "
            @go-back="activeComponent = 'parameters'"
            @cancel-process="cancelProcess"
            @cancel-publish="
              (processTag) => {
                cancelPublish(processTag);
              }
            "
            @go-to-only-publish="goTo('onlyPublish')"
            @sign-and-publish="
              (processTag) => {
                openModalPublish(processTag);
              }
            "
            @error-on-preview="
              (errorCode) => {
                activeErrorOnPreview(errorCode);
              }
            "
            :status="splitStatus"
            :processData="processData"
          />
        </template>
      </div>
    </div>
    <!-- Modal de confirmacion de publicación ONLY PUBLISH -->
    <zt-modal
      :active="publishModalActive"
      class="rounded"
      max-width="43rem"
      @close="publishModalActive = false"
    >
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <h4>
            {{ $t("message.publishDocuments.onlyPublish.modal.title") }}
          </h4>
        </div>
      </template>
      <div class="w-full pt-6 flex">
        <div class="w-11/12 mx-auto flex py-4">
          <div class="w-1/5 flex justify-center mt-2">
            <svg
              version="1.1"
              id="Capa_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              width="70"
              height="70"
              viewBox="0 0 70 70"
              style="enable-background: new 0 0 70 70"
              xml:space="preserve"
            >
              <g>
                <circle class="st0" cx="35" cy="35" r="33.3" />
                <path
                  class="st1"
                  d="M35,69.3C16.1,69.3,0.7,53.9,0.7,35S16.1,0.7,35,0.7S69.3,16.1,69.3,35S53.9,69.3,35,69.3z M35,2.6
                C17.2,2.6,2.6,17.2,2.6,35S17.2,67.4,35,67.4S67.4,52.8,67.4,35S52.8,2.6,35,2.6z"
                />
              </g>
              <path
                class="st2"
                d="M34.7,42.8c-0.9,0-1.7-0.8-1.7-1.7V22.2c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7v18.9
              C36.4,42,35.6,42.8,34.7,42.8z"
              />
              <path
                class="st2"
                d="M34.7,48.2c0.9,0,1.7,0.8,1.7,1.7s-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7S33.7,48.2,34.7,48.2z"
              />
            </svg>
          </div>
          <div
            class="
              w-4/5
              pt-2
              pb-4
              flex flex-wrap
              justify-start
              items-center
              px-4
            "
          >
            <span class="w-full text-zt-xl text-zt-dark-500 font-normal">
              {{
                $t("message.publishDocuments.onlyPublish.modal.title_container")
              }}
            </span>
            <span class="w-full text-zt-lg text-zt-dark-300 mt-8 font-normal">
              {{ $t("message.publishDocuments.onlyPublish.modal.description") }}
            </span>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div
          class="
            zt-modal-footer
            flex
            justify-end
            items-center
            p-4
            bg-zt-dark-100
          "
        >
          <div class="w-1/4">
            <zt-button
              @click="publishModalActive = false"
              data-vs-button="close-modal"
              class="ml-1 button-cancel-only-text w-11/12"
            >
              {{ $t("message.publishDocuments.onlyPublish.modal.cancel") }}
            </zt-button>
          </div>
          <div class="w-1/4">
            <zt-button
              @click="publish"
              data-vs-button="publish-document"
              class="ml-1 w-11/12"
              :disabled="publishLoading"
            >
              {{ $t("message.publishDocuments.onlyPublish.modal.confirm") }}
            </zt-button>
          </div>
        </div>
      </template>
    </zt-modal>
    <!-- MODAL PARA CONFIRMAR LA FIRMA Y PUBLICACION -->
    <zt-modal
      :active="modalConfirmSignAndPublish"
      max-width="45rem"
      @close="
        () => {
          certSignPass = '';
          proccessConfirmTag = '';
          modalConfirmSignAndPublish = false;
          errorSignAndPublish = '';
        }
      "
    >
      <template slot="modal-header" v-if="step === 1">
        <div class="p-4 font-semibold text-zt-lg">
          <h4>
            {{
              $t(
                `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.titleSelect`
              )
            }}
          </h4>
        </div>
      </template>
      <template slot="modal-header" v-else-if="step === 2">
        <div class="p-4 font-semibold text-zt-lg">
          <h4>
            {{
              $t(
                `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.title`
              )
            }}
          </h4>
        </div>
      </template>
      <div class="w-full p-6 flex">
        <div v-if="step === 1">
          <SelectCertificateModalBody
            @certificate-change-step="
              (stepNumber, selectedCert) => {
                certificateChangeStep(stepNumber, selectedCert);
              }
            "
          />
        </div>
        <div class="mx-auto flex py-3" v-else-if="step === 2">
          <div class="w-1/5 flex justify-center mt-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="70"
              height="70"
              fill="none"
              viewBox="0 0 70 70"
            >
              <circle
                cx="35"
                cy="35"
                r="34"
                fill="#fff"
                stroke="#FB8C00"
                stroke-width="2"
              />
              <path
                fill="#FB8C00"
                stroke="#FB8C00"
                d="M34.654 42.776c-.94 0-1.713-.772-1.713-1.713v-18.85c0-.941.772-1.713 1.713-1.713.94 0 1.713.772 1.713 1.713v18.85c0 .944-.753 1.713-1.713 1.713zM34.654 48.203c.94 0 1.713.772 1.713 1.713 0 .94-.772 1.712-1.713 1.712-.94 0-1.713-.772-1.713-1.712 0-.941.772-1.713 1.713-1.713z"
              />
            </svg>
          </div>
          <div class="w-4/5 flex flex-wrap justify-start items-center px-4">
            <span
              class="w-full text-zt-lg text-zt-dark-600 font-normal"
              v-html="
              $sanitize($t(
                  `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.description`
                ))
              "
            >
            </span>
            <p class="text-base py-2 text-zt-sm font-normal text-zt-dark-400">
              {{
                $t(
                  `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.advise`
                )
              }}
            </p>
            <div class="font-normal w-full">
              {{
                $t(
                  `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.selected`
                )
              }}
            </div>
            <div class="my-4 w-full">
              <div
                class="
                  flex
                  justify-center
                  items-center
                  bg-white
                  border-rounded border-gray-400
                  w-full
                "
              >
                <div class="mr-1 p-3">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="35"
                    fill="none"
                    viewBox="0 0 64 69"
                  >
                    <path
                      fill="#A6FFE4"
                      d="M32 64c17.673 0 32-14.327 32-32C64 14.327 49.673 0 32 0 14.327 0 0 14.327 0 32c0 17.673 14.327 32 32 32z"
                    />
                    <path
                      fill="#E56353"
                      d="M34.96 10.802h-5.84c-3.581 0-6.218 3.353-5.372 6.833l1.67 6.881c.336 1.38.917 2.689 1.716 3.863 1.336 1.962 2.05 4.28 2.05 6.654v1.689h5.712v-1.69c0-2.373.714-4.691 2.05-6.653.799-1.175 1.38-2.483 1.715-3.863l1.671-6.88c.846-3.481-1.79-6.834-5.372-6.834z"
                    />
                    <path
                      fill="#64798A"
                      d="M27.738 36.722h8.605c.626 0 1.133.507 1.133 1.133v3.288H26.604v-3.288c0-.626.508-1.133 1.134-1.133z"
                    />
                    <path
                      fill="#DC8744"
                      d="M16.214 41.143h31.652c.626 0 1.134.508 1.134 1.134v8.056c0 .313-.254.567-.567.567H15.647c-.313 0-.567-.254-.567-.567v-8.056c0-.626.508-1.134 1.134-1.134z"
                    />
                    <path
                      fill="#3A556A"
                      d="M17.823 50.9h28.435v1.273c0 .626-.508 1.134-1.134 1.134H18.956c-.626 0-1.133-.508-1.133-1.134V50.9z"
                    />
                    <path
                      fill="#404B58"
                      d="M23.738 46.618c-.385 0-.697-.311-.697-.696v-1.367c0-.385.312-.696.697-.696.384 0 .696.311.696.696v1.367c0 .385-.311.696-.696.696zM40.052 46.618c-.385 0-.697-.311-.697-.696v-1.367c0-.384.312-.696.697-.696.385 0 .696.312.696.696v1.367c0 .385-.312.697-.696.697zM31.937 47.67c-1.033 0-2.016-.448-2.696-1.229-.253-.29-.222-.73.068-.982.29-.253.73-.223.982.067.416.477 1.015.75 1.646.75.63 0 1.23-.273 1.646-.75.253-.29.692-.32.982-.067.29.252.32.692.068.982-.68.78-1.663 1.228-2.696 1.228z"
                    />
                    <circle cx="53.272" cy="58.451" r="10.358" fill="#54CAA6" />
                    <path
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M48.832 59.043l2.943 3.107 6.306-6.659"
                    />
                  </svg>
                </div>
                <div class="w-full">
                  <p class="text-lg mb-1 font-semibold">
                    {{ selectedCertificate.full_name }}
                  </p>
                  <p class="text-sm">{{ selectedCertificate.company_name }}</p>
                </div>
                <div class="flex flex-col">
                  <zt-button
                    outlined
                    data-vs-button="certificate-step1"
                    class="ml-2 mr-2 font-medium text-sm w-4/5"
                    @click="certificateChangeStep(1, '')"
                  >
                    {{
                      $t(
                        `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.changeCertificate`
                      )
                    }}
                  </zt-button>
                </div>
              </div>
            </div>
            <div class="w-full">
              <zt-input
                v-model="certSignPass"
                data-vs-input="sign-password"
                outlined
                :label="
                  $t(
                    `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.labelInput`
                  )
                "
                type="password"
              />
              <span
                class="text-base text-zt-danger absolute"
                v-show="errorSignAndPublish"
                >{{
                  $t(
                    `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.${errorSignAndPublish}`
                  )
                }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <template slot="modal-footer">
        <div
          class="
            zt-modal-footer
            flex
            justify-end
            items-center
            p-4
            bg-zt-dark-100
          "
        >
          <div class="w-1/4">
            <zt-button
            data-vs-button="cancel-button"
              @click="
                () => {
                  certSignPass = '';
                  proccessConfirmTag = '';
                  modalConfirmSignAndPublish = false;
                  errorSignAndPublish = '';
                }
              "
              class="ml-1 button-cancel-only-text w-11/12 text-base"
            >
              {{
                $t(
                  `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.cancel`
                )
              }}
            </zt-button>
          </div>
          <div class="w-1/4">
            <zt-button
              @click="postSignAndPublish()"
              data-vs-button="close-modal"
              :disabled="certSignPass.length < 1"
              :loader="loadingSignAndPublish"
              class="ml-1 w-11/12 text-base"
            >
              {{
                $t(
                  `message.publishDocuments.split_crop_and_sign.modalSignAndPublish.confirm`
                )
              }}
            </zt-button>
          </div>
        </div>
      </template>
    </zt-modal>
    <!-- MODAL HANDLEO DE ERRORES -->
    <zt-modal
      :active="errorActive"
      class="rounded"
      max-width="43rem"
      @close="closeErrorModal()"
    >
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <h4>{{ $t("message.certificates.newCertificate.errors.title") }}</h4>
        </div>
      </template>
      <modal-error :errorMsg="errorMsg" />
      <template slot="modal-footer">
        <div
          class="
            zt-modal-footer
            flex
            justify-end
            items-center
            p-4
            bg-zt-dark-100
          "
        >
          <div class="w-1/4">
            <zt-button @click="closeErrorModal()" data-vs-button="clean-errors" class="ml-1 w-11/12">
              {{ $t("message.certificates.newCertificate.gotIt") }}
            </zt-button>
          </div>
        </div>
      </template>
    </zt-modal>
  </div>
</template>

<script>
import PublishDocuments from "@/apiClient/PublishDocuments";
import ConfigMassivePublish from "./stepsMassivePublish/configMassivePublish.vue";
import OnlyPublish from "./stepsMassivePublish/onlyPublish.vue";
import OnlySign from "./stepsMassivePublish/onlySign.vue";
import SplitAndCrop from "./stepsMassivePublish/splitAndCrop.vue";
import ModalError from "./stepsMassivePublish/modalError/modalError";
import VueElementLoading from "vue-element-loading";
import SelectCertificateModalBody from "@/components/certificates/components/SelectCertificateModalBody.vue";

export default {
  inject: ["state", "mutations"],
  components: {
    ConfigMassivePublish,
    OnlyPublish,
    OnlySign,
    SplitAndCrop,
    VueElementLoading,
    ModalError,
    SelectCertificateModalBody,
  },
  data() {
    return {
      step: 1,
      publishDocuments: new PublishDocuments(),
      activeComponent: "parameters",
      loading: false,
      nextStep: "",
      publishModalActive: false,
      publishLoading: false,
      splitStatus: "",
      splitTag: "",
      processData: {},
      modalConfirmSignAndPublish: false,
      proccessConfirmTag: "",
      loadingSignAndPublish: false,
      errorSignAndPublish: "",
      certSignPass: "",
      errorMsg: "",
      errorActive: false,
      selectedCertificate: {},
    };
  },
  async created() {
    this.loading = true;
    await this.publishDocuments
      .getSplitStatus()
      .then((response) => {
        const { status, tag } = response.data.data;
        const statusSearch = ["new", "processed"];
        const found = statusSearch.find((element) => element === status);
        if (found) {
          this.splitStatus = status;
          this.splitTag = tag;
          this.activeComponent = response.data.data.type;
          this.processData = response.data.data;

        }
      })
      .catch((error) => {
        this.loading = false;
      });

    await this.publishDocuments
      .getUploadedFile()
      .then((response) => {
        this.processData = response.data.data;
        this.activeComponent = this.processData.type;
        this.mutations.setIdCarga(response.data.data.tag);
        this.mutations.setDocumentType(response.data.data.documentType);
        this.mutations.setPeriod(response.data.data.period);
        this.mutations.setUploadedFileData(response.data.data);
        this.mutations.setSendNotification(response.data.data.sendMail);
        this.loading = false;
      })
      .catch((error) => {
        this.loading = false;
      });
  },
  methods: {
    processesLink() {
      this.$router.push('/company/process-manager');
    },
    setNextStep(value) {
      this.nextStep = value;
      this.processData = {
        type: value,
      };
    },
    goTo(step) {
      this.activeComponent = step;
    },
    cancelProcess() {
      this.activeComponent === "parameters"
        ? this.$router.push("/MainDocumentPage")
        : (this.activeComponent = "parameters");
      this.splitStatus = "";
      this.nextStep = "";
    },

    cancelPublish(processTag) {
      this.loading = true;
      this.publishDocuments
        .cancelProccess(processTag)
        .then((res) => {
          this.splitStatus = "";
          this.activeComponent = this.$router.push("/MainDocumentPage");

          this.nextStep = "";
          this.loading = false;
        })
        .catch((e) => {
          let msg = this.$t(
            `message.publishDocuments.errors.ERROR_CANCEL_PROCESS`
          );
          this.activeModalError(msg);
          this.loading = false;
        });
    },
    async publish() {
      this.publishLoading = true;
      this.publishDocuments
        .publish(this.state.idCarga)
        .then((res) => {
          this.publishLoading = false;
          this.publishModalActive = false;
          this.mutations.cleanState();
          this.processesLink();
        })
        .catch((e) => {
          this.publishLoading = false;
        });
    },
    openModalPublish(processTag) {
      this.modalConfirmSignAndPublish = true;
      this.proccessConfirmTag = processTag;
    },
    postSignAndPublish() {
      this.loadingSignAndPublish = true;
      let params = {
        passphrase: this.certSignPass,
        tag: this.proccessConfirmTag,
        certId: this.selectedCertificate.id,
      };
      let signPromise =
        this.activeComponent === "sign_and_publish"
          ? this.publishDocuments.signMassive(params)
          : this.publishDocuments.signAndPublish(params);

      signPromise
        .then((res) => {
          this.proccessConfirmTag = "";
          this.modalConfirmSignAndPublish = false;
          this.loadingSignAndPublish = false;
          this.processesLink();
        })
        .catch((error) => {
          this.errorSignAndPublish = error.response.data.codes[0].code;
          if (this.errorSignAndPublish === "SIGN_DOCUMENT_CERT_NO_EXISTS") {
            this.modalConfirmSignAndPublish = false;
            let msg = this.$t(
              `message.publishDocuments.errors.${this.errorSignAndPublish}`
            );
            this.activeModalError(msg);
            this.certSignPass = "";
          }
          this.loadingSignAndPublish = false;
        });
    },
    activeErrorOnPreview(errorCode) {
      let msg = "";
      if (errorCode === "PAGE_REQUESTED_NOT_FOUND") {
        msg = this.$t(`message.publishDocuments.errors.${errorCode}`);
      } else {
        msg = this.$t(`message.publishDocuments.errors.ERROR_PREVIEW_GENERAL`);
      }
      this.activeModalError(msg);
    },
    activeModalError(msg) {
      this.errorMsg = msg;
      this.errorActive = true;
    },
    closeErrorModal() {
      this.errorMsg = "";
      this.errorSignAndPublish = "";
      this.errorActive = false;
    },
    certificateChangeStep(stepNumber, selectedCert) {
      this.step = stepNumber;
      this.selectedCertificate = selectedCert;
    },
  },
};
</script>

<style lang="scss" scoped>
.gap-2 {
  gap: 2rem;
}
.border-zt-info {
  border: 1px solid #03a9f4;
}

.main-container {
  min-height: calc(100vh - 120px);
}

.container {
  box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px 0 rgba(0, 0, 0, 0.12),
    0 3px 4px 0 rgba(0, 0, 0, 0.14);
}

.button-cancel-only-text {
  background-color: #f5f5f5 !important;
  color: #949494 !important;
}
.zt-button {
  font-weight: 500;
  box-shadow: none;
}
//SVG modal
.st0 {
  fill: #ffffff;
  stroke: #f68c11;
  stroke-width: 0.25;
}
.st1 {
  fill: #fb8c00;
  stroke: #f68c11;
  stroke-width: 0.25;
}
.st2 {
  fill: #fb8c00;
  stroke: #fb8c00;
}
::v-deep .border-rounded {
  border-radius: 0.75rem;
  border-width: 1px;
}
</style>
